<template>
  <div class="">
    <div class="p-2 border-b-2" v-for="user of users" :key="user._id">
      <div class="flex items-center">
        <img
          alt="user"
          class="rounded-full w-8 h-8"
          :src="`${$imageURL}/${user._user.userImage}`"
          v-if="
            user._user.hasOwnProperty('userImage') &&
            user._user.userImage !== 'null' &&
            user._user.userImage !== '' &&
            user._user.userImage !== null
          "
        />
        <b-avatar
          variant="info "
          class="p-2 text-xl cust-avatar"
          size="lg"
          v-else
        ></b-avatar>
        <div class="ml-4">
          <p
            class="text-lg font-semibold text-black"
            v-if="!user._user.isAnonymous"
          >
            {{ user._user.firstname }}
          </p>
          <p
            class="text-lg font-semibold text-black"
            v-if="user._user.isAnonymous"
          >
            Anonymous User
          </p>
        </div>
      </div>
    </div>
    <button v-if="users.length && showLoadMore" @click="loadMore()">
      Load More
    </button>
  </div>
</template>

<script>
export default {
  props: {
    users: {
      type: Object,
    },
    showLoadMore: {
      type: Boolean,
    },
  },
  methods: {
    loadMore() {
      this.$emit("getLikeUsers");
    },
  },
};
</script>
